import { render, staticRenderFns } from "./OrgCourses.vue?vue&type=template&id=71378aa7&scoped=true"
import script from "./OrgCourses.vue?vue&type=script&lang=js"
export * from "./OrgCourses.vue?vue&type=script&lang=js"
import style0 from "./OrgCourses.vue?vue&type=style&index=0&id=71378aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71378aa7",
  null
  
)

export default component.exports